import { Component, EventEmitter, Injector, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDateRangePicker, MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-date-range-picker-projection',
  templateUrl: './date-range-picker-projection.component.html',
  exportAs: 'dateRangePickerProjection',
  styleUrls: ['./date-range-picker-projection.component.scss']
})
export class DateRangePickerProjectionComponent implements OnInit {

  @ViewChild(MatDateRangePicker) public dateRangePicker: MatDateRangePicker<any>;

  @Input() projection: boolean = false;
  @Input() startDate: string | Date;
  @Input() endDate: string | Date;

  // always true:
  @Input() usingWeekPicker: boolean = true;
  @Output() dateChanged: EventEmitter<{
    start: string,
    end: string
  }> = new EventEmitter();
  constructor(private injector: Injector) {
    if (!this.startDate && !this.endDate) {
      this.initDate();
    } else if (this.startDate && this.endDate) {
      this.range.controls['start'].setValue(this.startDate);
      this.range.controls['end'].setValue(this.endDate);
    }
  }
  ngAfterViewInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
    const startDateChanged = changes.startDate;
    if (startDateChanged?.currentValue !== startDateChanged?.previousValue) {
      this.startDate = startDateChanged.currentValue;
      // Convert string date to Date object for the picker, using local timezone interpretation
      const startDateObj = typeof this.startDate === 'string' 
        ? new Date(this.startDate + 'T00:00:00') 
        : this.startDate;
      this.range.controls['start'].setValue(startDateObj);
    }

    const endDateChanged = changes.endDate;
    if (endDateChanged?.currentValue !== endDateChanged?.previousValue) {
      this.endDate = endDateChanged.currentValue;
      // Convert string date to Date object for the picker, using local timezone interpretation
      const endDateObj = typeof this.endDate === 'string' 
        ? new Date(this.endDate + 'T00:00:00') 
        : this.endDate;
      this.range.controls['end'].setValue(endDateObj);
    }
  }
  range = new FormGroup({
    start: new FormControl(null),
    end: new FormControl(null),
  });

  ngOnInit() {
  }

  emitResult(data: MatDatepickerInputEvent<any, any>, type: string) {
    this.range.controls[type].setValue(data.value);
    const startValue = this.range.controls.start.value;
    const endValue = this.range.controls.end.value;
    
    if (startValue && endValue) {
      const startDate = new Date(startValue);
      const endDate = new Date(endValue);
      
      // Allow equal dates or end date after start date
      if (endDate >= startDate) {
        this.dateChanged.emit(this.range.value);
      }
    }
  }
  initDate() {
    this.range.controls.start.setValue(new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]);
    this.range.controls.end.setValue(new Date(Date.now()).toISOString().split('T')[0]);
    this.dateChanged.emit(this.range.value);
  }

}
